/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
	AddOrUpdateServiceTeamMembersRequest,
	CreateServiceTeamRequest,
	CreateServiceTeamResponse,
	DeleteServiceTeamMembersRequest,
	LifeCycleStage,
	SearchServiceTeamsResponse,
	ServiceTeamSortField,
	ServiceTeamWithDetails,
	SortDirection,
	UpdateServiceTeamRequest,
	UpdateServiceTeamsToClientsAssignmentRequest,
} from '../models/index';
import {
	AddOrUpdateServiceTeamMembersRequestFromJSON,
	AddOrUpdateServiceTeamMembersRequestToJSON,
	CreateServiceTeamRequestFromJSON,
	CreateServiceTeamRequestToJSON,
	CreateServiceTeamResponseFromJSON,
	CreateServiceTeamResponseToJSON,
	DeleteServiceTeamMembersRequestFromJSON,
	DeleteServiceTeamMembersRequestToJSON,
	LifeCycleStageFromJSON,
	LifeCycleStageToJSON,
	SearchServiceTeamsResponseFromJSON,
	SearchServiceTeamsResponseToJSON,
	ServiceTeamSortFieldFromJSON,
	ServiceTeamSortFieldToJSON,
	ServiceTeamWithDetailsFromJSON,
	ServiceTeamWithDetailsToJSON,
	SortDirectionFromJSON,
	SortDirectionToJSON,
	UpdateServiceTeamRequestFromJSON,
	UpdateServiceTeamRequestToJSON,
	UpdateServiceTeamsToClientsAssignmentRequestFromJSON,
	UpdateServiceTeamsToClientsAssignmentRequestToJSON,
} from '../models/index';

export interface AddOrUpdateServiceTeamMembersOperationRequest {
	encodedServiceTeamRID: string;
	xBffCsrf?: string;
	addOrUpdateServiceTeamMembersRequest?: AddOrUpdateServiceTeamMembersRequest;
}

export interface AddServiceTeamsToClientsRequest {
	xBffCsrf?: string;
	updateServiceTeamsToClientsAssignmentRequest?: UpdateServiceTeamsToClientsAssignmentRequest;
}

export interface CreateServiceTeamOperationRequest {
	xBffCsrf?: string;
	createServiceTeamRequest?: CreateServiceTeamRequest;
}

export interface DeleteServiceTeamRequest {
	encodedServiceTeamRID: string;
	xBffCsrf?: string;
}

export interface GetServiceTeamRequest {
	encodedServiceTeamRID: string;
	xBffCsrf?: string;
	includeMemberDetails?: boolean;
	includeAssignmentCounts?: boolean;
	includeActions?: boolean;
}

export interface RemoveServiceTeamMembersRequest {
	encodedServiceTeamRID: string;
	xBffCsrf?: string;
	deleteServiceTeamMembersRequest?: DeleteServiceTeamMembersRequest;
}

export interface RemoveServiceTeamsFromClientsRequest {
	xBffCsrf?: string;
	updateServiceTeamsToClientsAssignmentRequest?: UpdateServiceTeamsToClientsAssignmentRequest;
}

export interface SearchServiceTeamsRequest {
	xBffCsrf?: string;
	includeMemberDetails?: boolean;
	includeAssignmentCounts?: boolean;
	includeActions?: boolean;
	lifeCycleStages?: Array<LifeCycleStage>;
	search?: string;
	continuationToken?: string;
	sortField?: ServiceTeamSortField;
	sortDirection?: SortDirection;
	skip?: number;
	limit?: number;
}

export interface UpdateServiceTeamOperationRequest {
	encodedServiceTeamRID: string;
	xBffCsrf?: string;
	updateServiceTeamRequest?: UpdateServiceTeamRequest;
}

/**
 * ServiceTeamsApi - interface
 *
 * @export
 * @interface ServiceTeamsApiInterface
 */
export interface ServiceTeamsApiInterface {
	/**
	 * Endpoint adds the listed members to the specified service team with the specified contact type. If the member already exists in the team, its contact type will be updated. Requires client_serviceteam:create permission.
	 * @summary Add or Update multiple service team members on a service team
	 * @param {string} encodedServiceTeamRID
	 * @param {string} [xBffCsrf]
	 * @param {AddOrUpdateServiceTeamMembersRequest} [addOrUpdateServiceTeamMembersRequest] Payload to add or update multiple service team members of a service team
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceTeamsApiInterface
	 */
	addOrUpdateServiceTeamMembersRaw(
		requestParameters: AddOrUpdateServiceTeamMembersOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Endpoint adds the listed members to the specified service team with the specified contact type. If the member already exists in the team, its contact type will be updated. Requires client_serviceteam:create permission.
	 * Add or Update multiple service team members on a service team
	 */
	addOrUpdateServiceTeamMembers(
		requestParameters: AddOrUpdateServiceTeamMembersOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Endpoint adds the listed service teams to the listed client organizations. If the service team already exists on the client, then it will be ignored.
	 * @summary Assigns multiple service teams to multiple clients
	 * @param {string} [xBffCsrf]
	 * @param {UpdateServiceTeamsToClientsAssignmentRequest} [updateServiceTeamsToClientsAssignmentRequest] Payload to add multiple service teams to multiple client organizations
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceTeamsApiInterface
	 */
	addServiceTeamsToClientsRaw(
		requestParameters: AddServiceTeamsToClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Endpoint adds the listed service teams to the listed client organizations. If the service team already exists on the client, then it will be ignored.
	 * Assigns multiple service teams to multiple clients
	 */
	addServiceTeamsToClients(
		requestParameters: AddServiceTeamsToClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Endpoint creates a service team. Requires client_serviceteam:create permission.
	 * @summary Create a service team
	 * @param {string} [xBffCsrf]
	 * @param {CreateServiceTeamRequest} [createServiceTeamRequest] Payload to create a service team
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceTeamsApiInterface
	 */
	createServiceTeamRaw(
		requestParameters: CreateServiceTeamOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<CreateServiceTeamResponse>>;

	/**
	 * Endpoint creates a service team. Requires client_serviceteam:create permission.
	 * Create a service team
	 */
	createServiceTeam(
		requestParameters: CreateServiceTeamOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<CreateServiceTeamResponse>;

	/**
	 * Endpoint deletes a service team by its RID. Requires client_serviceteam:delete permission.
	 * @summary Delete a service team
	 * @param {string} encodedServiceTeamRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceTeamsApiInterface
	 */
	deleteServiceTeamRaw(
		requestParameters: DeleteServiceTeamRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Endpoint deletes a service team by its RID. Requires client_serviceteam:delete permission.
	 * Delete a service team
	 */
	deleteServiceTeam(
		requestParameters: DeleteServiceTeamRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Retrieve a service team by its RID
	 * @summary Get a service team by RID
	 * @param {string} encodedServiceTeamRID
	 * @param {string} [xBffCsrf]
	 * @param {boolean} [includeMemberDetails] Include details about the members of the service team. Defaults to false.
	 * @param {boolean} [includeAssignmentCounts] Include the client entity assignment counts of the service team. Defaults to false.
	 * @param {boolean} [includeActions] Include the actions the current user can perform on the service team. Defaults to false.
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceTeamsApiInterface
	 */
	getServiceTeamRaw(
		requestParameters: GetServiceTeamRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ServiceTeamWithDetails>>;

	/**
	 * Retrieve a service team by its RID
	 * Get a service team by RID
	 */
	getServiceTeam(
		requestParameters: GetServiceTeamRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ServiceTeamWithDetails>;

	/**
	 * Endpoint deletes the listed service team members from the specified service team. If the member does not exist in the team, then it will be ignored. Requires client_serviceteam:delete permission.
	 * @summary Delete multiple service team members from a service team
	 * @param {string} encodedServiceTeamRID
	 * @param {string} [xBffCsrf]
	 * @param {DeleteServiceTeamMembersRequest} [deleteServiceTeamMembersRequest] Payload to remove multiple service teams from multiple client organizations
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceTeamsApiInterface
	 */
	removeServiceTeamMembersRaw(
		requestParameters: RemoveServiceTeamMembersRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Endpoint deletes the listed service team members from the specified service team. If the member does not exist in the team, then it will be ignored. Requires client_serviceteam:delete permission.
	 * Delete multiple service team members from a service team
	 */
	removeServiceTeamMembers(
		requestParameters: RemoveServiceTeamMembersRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Endpoint removes the listed service teams from the listed client organizations. If the service team does not exist on the client, then it will be ignored.
	 * @summary Removes the assignment of multiple service teams from multiple clients
	 * @param {string} [xBffCsrf]
	 * @param {UpdateServiceTeamsToClientsAssignmentRequest} [updateServiceTeamsToClientsAssignmentRequest] Payload to remove multiple service teams from multiple client organizations
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceTeamsApiInterface
	 */
	removeServiceTeamsFromClientsRaw(
		requestParameters: RemoveServiceTeamsFromClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Endpoint removes the listed service teams from the listed client organizations. If the service team does not exist on the client, then it will be ignored.
	 * Removes the assignment of multiple service teams from multiple clients
	 */
	removeServiceTeamsFromClients(
		requestParameters: RemoveServiceTeamsFromClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Search for and return a list of service teams for the current account
	 * @summary Search service teams
	 * @param {string} [xBffCsrf]
	 * @param {boolean} [includeMemberDetails] Include details about the members of the service team. Defaults to false.
	 * @param {boolean} [includeAssignmentCounts] Include the client entity assignment counts of the service team. Defaults to false.
	 * @param {boolean} [includeActions] Include the actions the current user can perform on the service team. Defaults to false.
	 * @param {Array<LifeCycleStage>} [lifeCycleStages]
	 * @param {string} [search] Search term. This will be used to filter the results. Searches the service team name and description.
	 * @param {string} [continuationToken] Continuation token for pagination returned from previous search
	 * @param {ServiceTeamSortField} [sortField]
	 * @param {SortDirection} [sortDirection]
	 * @param {number} [skip]
	 * @param {number} [limit]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceTeamsApiInterface
	 */
	searchServiceTeamsRaw(
		requestParameters: SearchServiceTeamsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<SearchServiceTeamsResponse>>;

	/**
	 * Search for and return a list of service teams for the current account
	 * Search service teams
	 */
	searchServiceTeams(
		requestParameters: SearchServiceTeamsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<SearchServiceTeamsResponse>;

	/**
	 * Endpoint updates a service team by its RID. Requires client_serviceteam:modify permission.
	 * @summary Update a service team
	 * @param {string} encodedServiceTeamRID
	 * @param {string} [xBffCsrf]
	 * @param {UpdateServiceTeamRequest} [updateServiceTeamRequest] Payload to update a service team
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ServiceTeamsApiInterface
	 */
	updateServiceTeamRaw(
		requestParameters: UpdateServiceTeamOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Endpoint updates a service team by its RID. Requires client_serviceteam:modify permission.
	 * Update a service team
	 */
	updateServiceTeam(
		requestParameters: UpdateServiceTeamOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;
}

/**
 *
 */
export class ServiceTeamsApi extends runtime.BaseAPI implements ServiceTeamsApiInterface {
	/**
	 * Endpoint adds the listed members to the specified service team with the specified contact type. If the member already exists in the team, its contact type will be updated. Requires client_serviceteam:create permission.
	 * Add or Update multiple service team members on a service team
	 */
	async addOrUpdateServiceTeamMembersRaw(
		requestParameters: AddOrUpdateServiceTeamMembersOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedServiceTeamRID === null ||
			requestParameters.encodedServiceTeamRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedServiceTeamRID',
				'Required parameter requestParameters.encodedServiceTeamRID was null or undefined when calling addOrUpdateServiceTeamMembers.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/serviceteams/{encodedServiceTeamRID}/members`.replace(
					`{${'encodedServiceTeamRID'}}`,
					encodeURIComponent(String(requestParameters.encodedServiceTeamRID))
				),
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: AddOrUpdateServiceTeamMembersRequestToJSON(
					requestParameters.addOrUpdateServiceTeamMembersRequest
				),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Endpoint adds the listed members to the specified service team with the specified contact type. If the member already exists in the team, its contact type will be updated. Requires client_serviceteam:create permission.
	 * Add or Update multiple service team members on a service team
	 */
	async addOrUpdateServiceTeamMembers(
		requestParameters: AddOrUpdateServiceTeamMembersOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.addOrUpdateServiceTeamMembersRaw(requestParameters, initOverrides);
	}

	/**
	 * Endpoint adds the listed service teams to the listed client organizations. If the service team already exists on the client, then it will be ignored.
	 * Assigns multiple service teams to multiple clients
	 */
	async addServiceTeamsToClientsRaw(
		requestParameters: AddServiceTeamsToClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/serviceteams/assignments`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: UpdateServiceTeamsToClientsAssignmentRequestToJSON(
					requestParameters.updateServiceTeamsToClientsAssignmentRequest
				),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Endpoint adds the listed service teams to the listed client organizations. If the service team already exists on the client, then it will be ignored.
	 * Assigns multiple service teams to multiple clients
	 */
	async addServiceTeamsToClients(
		requestParameters: AddServiceTeamsToClientsRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.addServiceTeamsToClientsRaw(requestParameters, initOverrides);
	}

	/**
	 * Endpoint creates a service team. Requires client_serviceteam:create permission.
	 * Create a service team
	 */
	async createServiceTeamRaw(
		requestParameters: CreateServiceTeamOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<CreateServiceTeamResponse>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/serviceteams`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: CreateServiceTeamRequestToJSON(requestParameters.createServiceTeamRequest),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			CreateServiceTeamResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint creates a service team. Requires client_serviceteam:create permission.
	 * Create a service team
	 */
	async createServiceTeam(
		requestParameters: CreateServiceTeamOperationRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<CreateServiceTeamResponse> {
		const response = await this.createServiceTeamRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Endpoint deletes a service team by its RID. Requires client_serviceteam:delete permission.
	 * Delete a service team
	 */
	async deleteServiceTeamRaw(
		requestParameters: DeleteServiceTeamRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedServiceTeamRID === null ||
			requestParameters.encodedServiceTeamRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedServiceTeamRID',
				'Required parameter requestParameters.encodedServiceTeamRID was null or undefined when calling deleteServiceTeam.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/serviceteams/{encodedServiceTeamRID}`.replace(
					`{${'encodedServiceTeamRID'}}`,
					encodeURIComponent(String(requestParameters.encodedServiceTeamRID))
				),
				method: 'DELETE',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Endpoint deletes a service team by its RID. Requires client_serviceteam:delete permission.
	 * Delete a service team
	 */
	async deleteServiceTeam(
		requestParameters: DeleteServiceTeamRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.deleteServiceTeamRaw(requestParameters, initOverrides);
	}

	/**
	 * Retrieve a service team by its RID
	 * Get a service team by RID
	 */
	async getServiceTeamRaw(
		requestParameters: GetServiceTeamRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ServiceTeamWithDetails>> {
		if (
			requestParameters.encodedServiceTeamRID === null ||
			requestParameters.encodedServiceTeamRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedServiceTeamRID',
				'Required parameter requestParameters.encodedServiceTeamRID was null or undefined when calling getServiceTeam.'
			);
		}

		const queryParameters: any = {};

		if (requestParameters.includeMemberDetails !== undefined) {
			queryParameters['includeMemberDetails'] = requestParameters.includeMemberDetails;
		}

		if (requestParameters.includeAssignmentCounts !== undefined) {
			queryParameters['includeAssignmentCounts'] =
				requestParameters.includeAssignmentCounts;
		}

		if (requestParameters.includeActions !== undefined) {
			queryParameters['includeActions'] = requestParameters.includeActions;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/serviceteams/{encodedServiceTeamRID}`.replace(
					`{${'encodedServiceTeamRID'}}`,
					encodeURIComponent(String(requestParameters.encodedServiceTeamRID))
				),
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ServiceTeamWithDetailsFromJSON(jsonValue)
		);
	}

	/**
	 * Retrieve a service team by its RID
	 * Get a service team by RID
	 */
	async getServiceTeam(
		requestParameters: GetServiceTeamRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ServiceTeamWithDetails> {
		const response = await this.getServiceTeamRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Endpoint deletes the listed service team members from the specified service team. If the member does not exist in the team, then it will be ignored. Requires client_serviceteam:delete permission.
	 * Delete multiple service team members from a service team
	 */
	async removeServiceTeamMembersRaw(
		requestParameters: RemoveServiceTeamMembersRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedServiceTeamRID === null ||
			requestParameters.encodedServiceTeamRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedServiceTeamRID',
				'Required parameter requestParameters.encodedServiceTeamRID was null or undefined when calling removeServiceTeamMembers.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/serviceteams/{encodedServiceTeamRID}/members`.replace(
					`{${'encodedServiceTeamRID'}}`,
					encodeURIComponent(String(requestParameters.encodedServiceTeamRID))
				),
				method: 'PATCH',
				headers: headerParameters,
				query: queryParameters,
				body: DeleteServiceTeamMembersRequestToJSON(
					requestParameters.deleteServiceTeamMembersRequest
				),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Endpoint deletes the listed service team members from the specified service team. If the member does not exist in the team, then it will be ignored. Requires client_serviceteam:delete permission.
	 * Delete multiple service team members from a service team
	 */
	async removeServiceTeamMembers(
		requestParameters: RemoveServiceTeamMembersRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.removeServiceTeamMembersRaw(requestParameters, initOverrides);
	}

	/**
	 * Endpoint removes the listed service teams from the listed client organizations. If the service team does not exist on the client, then it will be ignored.
	 * Removes the assignment of multiple service teams from multiple clients
	 */
	async removeServiceTeamsFromClientsRaw(
		requestParameters: RemoveServiceTeamsFromClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/serviceteams/assignments`,
				method: 'DELETE',
				headers: headerParameters,
				query: queryParameters,
				body: UpdateServiceTeamsToClientsAssignmentRequestToJSON(
					requestParameters.updateServiceTeamsToClientsAssignmentRequest
				),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Endpoint removes the listed service teams from the listed client organizations. If the service team does not exist on the client, then it will be ignored.
	 * Removes the assignment of multiple service teams from multiple clients
	 */
	async removeServiceTeamsFromClients(
		requestParameters: RemoveServiceTeamsFromClientsRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.removeServiceTeamsFromClientsRaw(requestParameters, initOverrides);
	}

	/**
	 * Search for and return a list of service teams for the current account
	 * Search service teams
	 */
	async searchServiceTeamsRaw(
		requestParameters: SearchServiceTeamsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<SearchServiceTeamsResponse>> {
		const queryParameters: any = {};

		if (requestParameters.includeMemberDetails !== undefined) {
			queryParameters['includeMemberDetails'] = requestParameters.includeMemberDetails;
		}

		if (requestParameters.includeAssignmentCounts !== undefined) {
			queryParameters['includeAssignmentCounts'] =
				requestParameters.includeAssignmentCounts;
		}

		if (requestParameters.includeActions !== undefined) {
			queryParameters['includeActions'] = requestParameters.includeActions;
		}

		if (requestParameters.lifeCycleStages) {
			queryParameters['lifeCycleStages'] = requestParameters.lifeCycleStages;
		}

		if (requestParameters.search !== undefined) {
			queryParameters['search'] = requestParameters.search;
		}

		if (requestParameters.continuationToken !== undefined) {
			queryParameters['continuationToken'] = requestParameters.continuationToken;
		}

		if (requestParameters.sortField !== undefined) {
			queryParameters['sortField'] = requestParameters.sortField;
		}

		if (requestParameters.sortDirection !== undefined) {
			queryParameters['sortDirection'] = requestParameters.sortDirection;
		}

		if (requestParameters.skip !== undefined) {
			queryParameters['skip'] = requestParameters.skip;
		}

		if (requestParameters.limit !== undefined) {
			queryParameters['limit'] = requestParameters.limit;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/serviceteams`,
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			SearchServiceTeamsResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Search for and return a list of service teams for the current account
	 * Search service teams
	 */
	async searchServiceTeams(
		requestParameters: SearchServiceTeamsRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<SearchServiceTeamsResponse> {
		const response = await this.searchServiceTeamsRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Endpoint updates a service team by its RID. Requires client_serviceteam:modify permission.
	 * Update a service team
	 */
	async updateServiceTeamRaw(
		requestParameters: UpdateServiceTeamOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedServiceTeamRID === null ||
			requestParameters.encodedServiceTeamRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedServiceTeamRID',
				'Required parameter requestParameters.encodedServiceTeamRID was null or undefined when calling updateServiceTeam.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
				]
			);
		}

		const response = await this.request(
			{
				path: `/serviceteams/{encodedServiceTeamRID}`.replace(
					`{${'encodedServiceTeamRID'}}`,
					encodeURIComponent(String(requestParameters.encodedServiceTeamRID))
				),
				method: 'PUT',
				headers: headerParameters,
				query: queryParameters,
				body: UpdateServiceTeamRequestToJSON(requestParameters.updateServiceTeamRequest),
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Endpoint updates a service team by its RID. Requires client_serviceteam:modify permission.
	 * Update a service team
	 */
	async updateServiceTeam(
		requestParameters: UpdateServiceTeamOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.updateServiceTeamRaw(requestParameters, initOverrides);
	}
}
